// src/tradingData.js

export const tradingHistory = [
  { date: "2026-02-04", volume: 35.2, cvd: 0.8, spotCvd: -1.2, funding: 0.0010, oi: 78.5, bidAsk: 45.0 },
  { date: "2026-02-05", volume: 38.5, cvd: 1.1, spotCvd: -2.5, funding: 0.0005, oi: 80.2, bidAsk: 60.2 },
  { date: "2026-02-06", volume: 45.8, cvd: 2.3, spotCvd: -3.8, funding: -0.0005, oi: 82.1, bidAsk: 85.5 },
  { date: "2026-02-07", volume: 32.1, cvd: 1.5, spotCvd: -4.2, funding: -0.0020, oi: 83.5, bidAsk: 110.0 },
  { date: "2026-02-08", volume: 42.1, cvd: 1.8, spotCvd: -5.1, funding: -0.0039, oi: 85.5, bidAsk: 112.4 },
  { date: "2026-02-09", volume: 64.1, cvd: -1.45, spotCvd: -8.05, funding: 0.0008, oi: 84.2, bidAsk: -412.5 },
  { date: "2026-02-10", volume: 45.0, cvd: -2.1, spotCvd: -9.2, funding: 0.0012, oi: 86.5, bidAsk: -320.0 },
];

export const getIndicatorData = (targetDate, days = 7) => {
  const endDate = new Date(targetDate);
  const data = [];
  
  for (let i = days - 1; i >= 0; i--) {
    const d = new Date(endDate);
    d.setDate(d.getDate() - i);
    const ds = d.toISOString().split('T')[0];
    const record = tradingHistory.find(h => h.date === ds);
    
    if (record) {
      data.push({
        ...record,
        displayDate: ds.split('-').slice(1).join('/')
      });
    } else {
      // Generate some dummy baseline if no record found
      data.push({
        displayDate: ds.split('-').slice(1).join('/'),
        volume: 30 + Math.random() * 10,
        cvd: Math.random() * 2 - 1,
        spotCvd: -Math.random() * 5,
        funding: 0.0001,
        oi: 75,
        bidAsk: Math.random() * 100 - 50
      });
    }
  }
  return data;
};
